// extracted by mini-css-extract-plugin
export default {"svgAnimation":"HQwg4K2ct2hLaJYnD1QA","svgSuccess":"WLh6E92Y8CQjJhyj1AT9","ok":"PNn7aRtPcg_9aEM0um1t"};